// extracted by mini-css-extract-plugin
export default {"container":"OurClients_container__y2W5L","cardContainer":"OurClients_cardContainer__bsPlH"};